import { EventEmitter, Injectable } from '@angular/core';
import { IHandlerService } from './ihandler';

declare const reqCaronteAndroid;

declare global {
	interface Window {
		caronteResponse: (rel: string, data: string) => any;
		webkit: any;
		JSBridge: any;
	}
}

@Injectable({ providedIn: 'root' })
export class HandlerService implements IHandlerService {
	private EmmitChange = new EventEmitter<{ rel; data }>();
    private reg: RegExp = new RegExp('(error|Error|erro|Erro)|(400|500|404|406)');

	constructor() {
		window.caronteResponse = (rel: string, data: string) => {
			this.EmmitChange.emit({ rel, data });
		};
	}

    caronteCommunicator<T>(rel: string, params?: object, charonParams?: object, itoken?: boolean, pathParams?: object): Promise<T> {
        /**
         * Send mensage for IOS or Android
         */
        console.log("rel", rel)
        console.log("params", params)
        console.log("charonParams", charonParams)
        console.log("itoken", itoken)
        console.log("pathParams", pathParams)

        try {
            if (window.webkit?.messageHandlers?.reqCaronteIOS) {
                this.comunicationIos(rel, params, charonParams, itoken, pathParams);
            } else {
                this.comunicationAndroid(
                    rel,
                    params,
                    charonParams === null ? pathParams : charonParams,
                    itoken
                  );            
                }

        } catch (e) {
            console.log("error")
            return Promise.reject('Falha enviando request para device');
        }

        return new Promise((resolve, reject) => {
            this.EmmitChange.subscribe(value => {
                if (value.data) {
                    if (this.reg.test(value.data)) {
                        reject(value.data);
                    }
                }

                if (value.rel === rel) {
                    resolve(value.data);
                }
            });
        });
    }

    private comunicationIos(rel: string, params?: object, charonParams?: object, itoken?: boolean, pathParams?: object) {
        window.webkit.messageHandlers.reqCaronteIOS
            .postMessage({ rel, params, charonParams, itoken, pathParams });
    }

    private comunicationAndroid(rel: string, params?: object, charonParams?: object, itoken?: boolean) {
        console.log("caiu no android")
        const param = JSON.stringify({params});
        const charonParam = JSON.stringify({charonParams});
        reqCaronteAndroid.postMessage(rel, param, charonParam, itoken);
    }
}
